import type { StoryBeat, StoryBlankSpec, StoryScript } from '../data/stories/types';
import type { Story2Seed } from '../data/story2/seeds';
import type { Story2BeatResponse } from './story2Api';

export function buildStory2Script(
  seed: Story2Seed,
  dynamicBeats: StoryBeat[],
  dynamicBlanks: Record<string, StoryBlankSpec>,
): StoryScript {
  return {
    id: `story2-${seed.id}`,
    title: seed.title,
    storyLevel: 1,
    defaultBlankLength: 12,
    blanks: dynamicBlanks,
    beats: [...seed.openingBeats, ...dynamicBeats],
  };
}

export function mergeBeatIntoScript(
  script: StoryScript,
  payload: Story2BeatResponse,
  beatId: string,
): StoryScript {
  const beat: StoryBeat = { id: beatId, template: payload.template };
  const blanks = { ...script.blanks };
  if (payload.blanks) {
    for (const [k, v] of Object.entries(payload.blanks)) {
      blanks[k] = { ...blanks[k], ...v };
    }
  }
  return {
    ...script,
    blanks,
    beats: [...script.beats, beat],
  };
}
